import {
  getVendorWordPlural,
  VendorTaxonomyKey,
  getVendorWordSingular,
} from '@zola-helpers/client/dist/es/marketplace';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import H from '@zola/zola-ui/src/typography/Headings';
import P from '@zola/zola-ui/src/typography/Paragraphs';

import cx from 'classnames';

import styles from './emptyState.module.less';

type EmptyStateProps = React.HTMLAttributes<HTMLElement> & {
  taxonomyKey: VendorTaxonomyKey;
  showEditPreferences: () => void;
};

export const EmptyState = ({ className, showEditPreferences, taxonomyKey }: EmptyStateProps) => {
  const vendorTypeSingular = getVendorWordSingular(taxonomyKey);
  const vendorTypePlural = getVendorWordPlural(taxonomyKey);

  return (
    <div className={cx(styles.emptyState, className)}>
      <H.Title3>Looks like we couldn&apos;t find any perfect matches...</H.Title3>
      <P.BodyBase>
        Try updating your {vendorTypeSingular} preferences, or scroll down to browse tons of{' '}
        {vendorTypePlural} we know you&apos;ll love.
      </P.BodyBase>
      <LinkV2 role="button" onClick={showEditPreferences} noTextTransform>
        Edit your preferences
      </LinkV2>
    </div>
  );
};
